module.exports = __webpack_public_path__ + "static/media/Avatars_Female-11.87390fd3.png";